var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQdBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.6 188",
    style: {
      enableBackground: "new 0 0 50.6 188"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00B1D9;}\n\t.st1{fill:#9CB6B7;}\n\t.st2{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000016792960537037345330000005639569681634217088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 0.3,
    className: "st0",
    width: 8.6,
    height: 131.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.7,132h-8.5v-12h8.5V132z M28.7,108h-8.5V96h8.5V108z M28.7,84h-8.5V72h8.5V84z M28.7,59.9h-8.5v-12h8.5 V59.9z M28.7,35.9h-8.5v-12h8.5V35.9z M28.7,11.9h-8.5v-12h8.5V11.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.6,174.2c-0.5-0.2-1-0.6-1.5-1c-0.5-0.5-1.1-1-1.6-1.6c-0.5-0.6-1-1.2-1.4-1.7c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.2,0-0.3,0c-1.6,0-3-0.3-3.9-0.9c-1-0.6-1.7-1.5-2.1-2.6c-0.4-1.2-0.6-2.5-0.6-4.1v-8.7c0-1.6,0.2-2.9,0.6-4 c0.4-1.1,1.1-2,2.1-2.6c1-0.6,2.3-0.9,3.9-0.9c1.7,0,3,0.3,4,0.9c1,0.6,1.7,1.5,2.1,2.6c0.4,1.1,0.6,2.5,0.6,4v8.7 c0,1.1-0.1,2.1-0.3,3c-0.2,0.9-0.6,1.7-1,2.3c-0.5,0.7-1.1,1.2-1.9,1.5c0.2,0.3,0.5,0.5,0.8,0.8c0.3,0.3,0.5,0.6,0.8,0.8 c0.3,0.2,0.5,0.5,0.8,0.6L21.6,174.2z M16.6,166.7c0.7,0,1.2-0.2,1.6-0.5c0.3-0.3,0.6-0.7,0.7-1.3c0.1-0.5,0.2-1.1,0.2-1.8v-10.7 c0-0.7-0.1-1.2-0.2-1.8c-0.1-0.5-0.3-0.9-0.7-1.2c-0.3-0.3-0.9-0.4-1.6-0.4c-0.7,0-1.2,0.1-1.6,0.4c-0.3,0.3-0.6,0.7-0.7,1.2 c-0.1,0.5-0.2,1.1-0.2,1.8v10.7c0,0.6,0.1,1.2,0.2,1.8c0.1,0.5,0.3,1,0.7,1.3C15.4,166.6,15.9,166.7,16.6,166.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.7,176.5c-1,0-1.8-0.4-2.3-1.1c-0.5-0.7-0.8-1.9-0.8-3.5v-3.9c0-0.9,0.1-1.7,0.3-2.4 c0.2-0.7,0.5-1.3,1-1.7c0.4-0.4,1-0.6,1.8-0.6c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.4,1.1,0.7v-5.9h3v17.8h-3v-0.9 c-0.3,0.3-0.7,0.6-1.1,0.8C29.5,176.4,29.1,176.5,28.7,176.5z M29.8,174.5c0.2,0,0.3,0,0.6-0.1c0.2-0.1,0.4-0.2,0.6-0.3v-8.2 c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.1-0.6-0.1c-0.4,0-0.7,0.2-0.9,0.6c-0.2,0.4-0.3,0.9-0.3,1.4v4.8c0,0.4,0,0.8,0.1,1.1 c0.1,0.3,0.2,0.6,0.3,0.8C29.2,174.4,29.5,174.5,29.8,174.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQdBlue);
export default __webpack_public_path__ + "static/media/QdBlue.f25d22ef91a5f8459fcaa43aae60fec5.svg";
export { ForwardRef as ReactComponent };